import React from 'react';
import { Region, Country, Tour } from '@model/common';
import { LinkItem } from '@components/sitemap/styles';
import { useI18NextContext } from '@components/hooks';
import { TourLink } from '@components/common/next-link/tour-link';
import { SectionSeparator } from '@styles/layout';
import { Theme, useTheme } from '@emotion/react';
import { Dictionary, groupBy } from 'lodash';
import { TestId } from '@components/test-ids';
import { SectionTitle } from '@components/common/section-title';

export interface SitemapToursProps {
  destination: Region | Country;
  tours: Array<Tour>;
}

export const SitemapTours = ({ destination, tours }: SitemapToursProps) => {
  const t: any = useI18NextContext();
  const theme: Theme = useTheme();
  const { display } = destination;
  const toursByTripType: Dictionary<Tour[]> = groupBy(tours, (tour: Tour) => tour.type);

  return (
    <div data-testid={TestId.sitemap.tours.container}>
      {Object.entries(toursByTripType).map(([key, value]) => (
        <div key={key}>
          <SectionTitle heading={`${display} ${t(key)}`} />
          {value.map((tour: Tour) => {
            const { path, type, display } = tour;
            return (
              <LinkItem data-testid={TestId.sitemap.tours.link} key={path}>
                <TourLink path={path} tripType={type}>
                  {display}
                </TourLink>
              </LinkItem>
            );
          })}
          <SectionSeparator size={theme.custom.spacing.xLarge} />
        </div>
      ))}
    </div>
  );
};
